import { render } from "./Treedown.vue?vue&type=template&id=2509e9c3&scoped=true"
import script from "./Treedown.vue?vue&type=script&lang=js"
export * from "./Treedown.vue?vue&type=script&lang=js"

import "./Treedown.vue?vue&type=style&index=0&id=2509e9c3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2509e9c3"]])

export default __exports__